import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CONSTANTS } from "src/app/config";
import { LocalService } from "./local.service";
import { MatDialog } from "@angular/material";
import { AcknowledgementService } from "./acknowledgement.service";
import { AcknowldgementDialogComponent } from "src/app/acknowldgement-dialog/acknowldgement-dialog.component";
import { DashboardService } from "./dashboard.service";

@Injectable({
  providedIn: "root",
})
export class CommonRouteService {
  constructor(
    private router: Router,
    private acknowledgementService: AcknowledgementService,
    private dialog: MatDialog,
    readonly dashboardService: DashboardService
  ) {}

  isAnyIntersection(roles, userData) {
    return userData.roles.filter((element) => roles.includes(element.name));
  }
  isApproverRole(roles, userData) {
    return userData.roles.filter((element) => roles.includes(element.name));
  }

  navigateUser(userData, ignoreNavigation) {
        if(userData.company==null && userData.id==null){
        if(userData.pvieligible==true || userData.pvieligible==null ||  userData.pvieligible===false){
         this.router.navigateByUrl('/user-access-validation');   
            return false; 
        }
      }

   if((userData.company!=null && userData.id==null )&& userData.pvieligible===false){
           this.router.navigateByUrl('/enroll');
            return false; 
        }


    if (
      userData.companyBlocked ||
      (userData.companyEligibleChallengesDTO &&
        userData.companyEligibleChallengesDTO.companyBlocked)
    ) {
      this.router.navigateByUrl("/blocked");
      return false;
    }
  

    if (userData.grsUser && userData.onlyRedeemPoints && !userData.active) {
      this.router.navigateByUrl("/redeem-points");
      return false;
    }
    if (userData.onlyRedeemPoints) {
      this.router.navigateByUrl("/redeem-points");
      return false;
    }
    if (
      userData.userType == "PAM" &&
      !userData.pamDefaultSelection.pamBeGeoIdsDTO
    ) {
      this.router.navigateByUrl("/user-access-validation");
      return false;
    }
    let approver = LocalService.get("onlyApprover");
    let ciscoAdminRole = LocalService.get("ciscoAdminRole");
    let approverRole = LocalService.get("approverRole");
    let managerFlag;
    let sellerFlag;
    let approverFlag;
    if (
      !userData.grsUser ||
      (userData.grsUser && userData.active) ||
      (userData.grsUser && !userData.active && !userData.onlyRedeemPoints)
    ) {
      if (userData.active && userData.company.profileComplete) {
        managerFlag = false;
        sellerFlag = false;
        approverFlag = false;
        if (userData.hasOwnProperty("userType") && userData.userType == "PAM") {
          managerFlag = true;
        } else {
          const managerRoles = CONSTANTS.manager;
          const managerRolesIntersection = this.isAnyIntersection(
            managerRoles,
            userData
          );
          managerFlag = managerRolesIntersection.length ? true : false;
          const sellerRoles = CONSTANTS.seller;
          const sellerRolesIntersection = this.isAnyIntersection(
            sellerRoles,
            userData
          );
          sellerFlag = sellerRolesIntersection.length ? true : false;
        }
        if (ignoreNavigation) {
          return true;
        }
        if (
          ciscoAdminRole &&
          approverRole &&
          !(
            userData.hasOwnProperty("userType") && userData.userType == "PAM"
          ) &&
          managerFlag
        ) {
          this.router.navigateByUrl("/home/manager/manage-challenges");

          return;
        }

        if (managerFlag) {
          this.router.navigateByUrl("/home/manager/manage-challenges");
          this.getAcknowledgements("LEADER");

          return;
        }
        if (sellerFlag) {
          this.router.navigateByUrl("/home/seller/challenges");
          this.getAcknowledgements("SELLER");
          return;
        }

        if (approver) {
          this.router.navigateByUrl("/approver");
          return;
        }
      } else if (
        userData.hasOwnProperty("userType") &&
        userData.userType == "PAM" &&
        userData.active == false
      ) {
        if (userData.pamActivity.createProfleClicked) {
          this.router.navigateByUrl("/profile");
          return false;
        } else {
          // let val=await this.doAsyncTask();
          // if(val){
          this.router.navigateByUrl("/welcome");
          return false;
          // }
        }
      } else if (!userData.id && userData.userEnrolled && userData.pvieligible) {
        this.router.navigateByUrl("/profile");
        return false;
      } else if (
        userData.adminInPss &&
        !userData.company.profileComplete &&
        !userData.company.companyProfileInformationProvided
        // || !userData.taxInfo  // Note:: we are no longer validate tax info
      ) {
        this.router.navigateByUrl("/profile");
        return false;
        // else{
        //   return this.router.navigateByUrl('/profile');
        // }
      } else if (!userData.company.profileComplete) {
        this.router.navigateByUrl("/user-access-validation");
        return false;
      } else if (
        (userData.roles && userData.roles.length) ||
        (userData.pendingRoles && userData.pendingRoles.length)
      ) {
        this.router.navigateByUrl("/user-access-validation");
        return false;
      }
    }
    this.router.navigateByUrl("/profile");
    return false;
  }
  // Show the popup for acknowledgement
  getAcknowledgements(role) {
    this.acknowledgementService
      .getAcknowledgements(role)
      .subscribe((response) => {
        let revResponse = response.slice().reverse();
        if (revResponse) {
          revResponse.forEach((element) => {
            this.dialog.open(AcknowldgementDialogComponent, {
              data: { name: "acknowledgePopup", responseData: element },
              width: "600px",
              disableClose: true,
              panelClass: "acknowldgment",
            });
          });
        }
      });
  }

  async setupUserData(userData) {
    localStorage.setItem('selectedLanguage', 'English');
    if(userData.company){
        if(userData.company.region == 'EMEAR'){
          const offset = 420; 
          const offsetMillis = offset * 60 * 1000;
          const today = new Date();
          const millis = today.getTime();
          const pst = millis - offsetMillis; 
          const currentDate = new Date(pst);
          const  d = currentDate.getTime();
          const  j = new Date('July 25, 2020 23:59:59').getTime();
          if(j < d){
            return this.router.navigateByUrl('/blocked');
          }
        }
      }
    
    if (userData.hasOwnProperty("userType") && userData["userType"] == "PAM") {
      let regData = await this.getPartnerInfoData(userData);
      let getcountryList = await this.getcountryList(userData, regData);
      let beGeoData = await this.getBGeoId(userData, getcountryList);
      let pamDefaultSelection = {};
      pamDefaultSelection["countryGroup"] = getcountryList["countryGroups"][0];

      pamDefaultSelection["pamBeGeoIdsDTO"] = beGeoData;
      pamDefaultSelection["theater"] = regData["theaters"][0];

      LocalService.set("pamData", pamDefaultSelection);

      if (userData["pamDefaultSelection"]["pamBeGeoIdsDTO"]) {
        if (userData.company != null) {
          userData.company["id"] =
            userData["pamDefaultSelection"]["pamBeGeoIdsDTO"][
              "beGeoIds"
            ][0].companyId;
          userData["company"]["region"] =
            userData["pamDefaultSelection"]["pamBeGeoIdsDTO"][
              "beGeoIds"
            ][0].region;
        } else {
          userData.company = {
            region:
              userData["pamDefaultSelection"]["pamBeGeoIdsDTO"]["beGeoIds"][0]
                .region,
          };
        }
      }
      LocalService.set("userProfile", userData);
    }
    if (
      userData.roles &&
      userData.roles.find((ele) => ele.name === "AC_APPROVER") &&
      userData.roles.length == 1
    ) {
      LocalService.set("onlyApprover", true);
    } else {
      let approver: any = null;
      approver =
        userData.roles &&
        userData.roles.find((ele) => ele.name === "AC_APPROVER");
      const approverFlag = approver ? true : false;
      if (approverFlag) {
        let Role = { approverRole: true };
        LocalService.set("approverRole", Role);
      }
    }

    let ciscoAdmin =
      userData.roles &&
      userData.roles.find((item) => item.name === "CISCO_ADMIN");
    const ciscoAdminFlag = ciscoAdmin ? true : false;
    if (ciscoAdminFlag) {
      let Role = { ciscoAdminRole: true };
      LocalService.set("ciscoAdminRole", true);
    }
  }

  async navigateUserAfterLogin(userData) {
    this.setupUserData(userData);
    this.navigateUser(userData, false);
  }

  getPartnerInfoData(val) {
    var promise = new Promise((resolve, reject) => {
      this.dashboardService.getRegionList(val.username).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          console.log(error);
        }
      );
    });
    return promise;
  }
  getcountryList(userData, reg) {
    var promise = new Promise((resolve, reject) => {
      this.dashboardService
        .getCountryListRequest(userData.username, reg["theaters"][0])
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
          }
        );
    });
    return promise;
  }
  getBGeoId(userData, countryGrp) {
    let paramReq: any = {};
    paramReq.username = userData.username;
    paramReq.countries = [countryGrp["countryGroups"][0]];
    var promise = new Promise((resolve, reject) => {
      this.dashboardService.getBeGeoIdsRequest(paramReq).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          console.log(error);
        }
      );
    });
    return promise;
  }

  async navigateIncenticveProgram(userData, incentiveProgram?: string) {
    this.setupUserData(userData);
    this.navigateUserOfIncentiveProgram(userData, false, incentiveProgram);
  }

  navigateUserOfIncentiveProgram(
    userData,
    ignoreNavigation,
    incentiveProgram?: string
  ) {
    console.log("incentiveProgram common router ser", incentiveProgram);
          if(userData.company==null && userData.id==null){
        if(userData.pvieligible==true || userData.pvieligible==null ||  userData.pvieligible===false){
         this.router.navigateByUrl('/user-access-validation');   
            return false; 
        }
      }

    if((userData.company!=null && userData.id==null )&& userData.pvieligible===false){
           this.router.navigateByUrl('/enroll');
            return false; 
        }


    if (
      userData.companyBlocked ||
      (userData.companyEligibleChallengesDTO &&
        userData.companyEligibleChallengesDTO.companyBlocked)
    ) {
      this.router.navigateByUrl("/blocked");
      return false;
    }

    if (userData.grsUser && userData.onlyRedeemPoints && !userData.active) {
      this.router.navigateByUrl("/redeem-points");
      return false;
    }
    if (userData.onlyRedeemPoints) {
      this.router.navigateByUrl("/redeem-points");
      return false;
    }
    if (
      userData.userType == "PAM" &&
      !userData.pamDefaultSelection.pamBeGeoIdsDTO
    ) {
      this.router.navigateByUrl("/user-access-validation");
      return false;
    }
    let approver = LocalService.get("onlyApprover");
    let ciscoAdminRole = LocalService.get("ciscoAdminRole");
    let approverRole = LocalService.get("approverRole");
    let managerFlag;
    let sellerFlag;
    let approverFlag;
    if (
      !userData.grsUser ||
      (userData.grsUser && userData.active) ||
      (userData.grsUser && !userData.active && !userData.onlyRedeemPoints)
    ) {
      if (userData.active && userData.company.profileComplete) {
        managerFlag = false;
        sellerFlag = false;
        approverFlag = false;
        if (userData.hasOwnProperty("userType") && userData.userType == "PAM") {
          managerFlag = true;
        } else {
          const managerRoles = CONSTANTS.manager;
          const managerRolesIntersection = this.isAnyIntersection(
            managerRoles,
            userData
          );
          managerFlag = managerRolesIntersection.length ? true : false;
          const sellerRoles = CONSTANTS.seller;
          const sellerRolesIntersection = this.isAnyIntersection(
            sellerRoles,
            userData
          );
          sellerFlag = sellerRolesIntersection.length ? true : false;
        }
        if (ignoreNavigation) {
          return true;
        }
        if (
          ciscoAdminRole &&
          approverRole &&
          !(
            userData.hasOwnProperty("userType") && userData.userType == "PAM"
          ) &&
          managerFlag
        ) {
          // If badging navigate to account settings page
          if (incentiveProgram == "Badging") {
            this.router.navigateByUrl("/home/manager/account-details");
          } else {
            this.router.navigateByUrl("/home/manager/manage-challenges");
            this.getAcknowledgements("LEADER");
          }
          return;
        }
        if (managerFlag) {
          // If badging navigate to account settings page
          if (incentiveProgram == "Badging") {
            this.router.navigateByUrl("/home/manager/account-details");
          } else {
            this.router.navigateByUrl("/home/manager/manage-challenges");
            this.getAcknowledgements("LEADER");
          }

          return;
        }
        if (sellerFlag) {
          this.router.navigateByUrl("/home/seller/challenges");
          this.getAcknowledgements("SELLER");
          return;
        }

        if (approver) {
          this.router.navigateByUrl("/approver");
          return;
        }
      } else if (
        userData.hasOwnProperty("userType") &&
        userData.userType == "PAM" &&
        userData.active == false
      ) {
        if (userData.pamActivity.createProfleClicked) {
          this.router.navigateByUrl("/profile");
          return false;
        } else {
          // let val=await this.doAsyncTask();
          // if(val){
          this.router.navigateByUrl("/welcome");
          return false;
          // }
        }
      } else if (!userData.id && userData.userEnrolled && userData.pvieligible) {
        this.router.navigateByUrl("/profile");
        return false;
      } else if (
        userData.adminInPss &&
        !userData.company.profileComplete &&
        !userData.company.companyProfileInformationProvided
        // || !userData.taxInfo  // Note:: we are no longer validate tax info
      ) {
        this.router.navigateByUrl("/profile");
        return false;
        // else{
        //   return this.router.navigateByUrl('/profile');
        // }
      } else if (!userData.company.profileComplete) {
        this.router.navigateByUrl("/user-access-validation");
        return false;
      } else if (
        (userData.roles && userData.roles.length) ||
        (userData.pendingRoles && userData.pendingRoles.length)
      ) {
        this.router.navigateByUrl("/user-access-validation");
        return false;
      }
    }
    this.router.navigateByUrl("/profile");
    return false;
  }
}
